import { useEffect } from "react";
import { StyledMenu, StyledOutletLayout } from "../../../../../../../components/common/styles";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useAppDispatch } from "../../../../../../../store/config";
import {
  getWorkoutStart,
  resetWorkout,
} from "../../../../../../../store/features/workout/workout-slice";

interface MenuItem {
  key: string;
  label: string;
  path: string;
  disabled?: boolean;
}

export const Workout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isNew: boolean = location.pathname.includes("/workouts/add");
  const dispatch = useAppDispatch();
  const { workoutId } = useParams<{ workoutId: string }>();

  const menuItems: MenuItem[] = [
    {
      key: "workout-details",
      label: t("Workout Details"),
      path: ``,
    },
    {
      key: "workout-content",
      label: t("Workout Content"),
      path: `workout-content`,
      disabled: isNew,
    },
  ];
  const [currentTab, setCurrentTab] = useState<string>(menuItems[0].key);

  useEffect(() => {
    if (!isNew) {
      dispatch(getWorkoutStart({ workoutId: workoutId || "" }));
    }
    return () => {
      dispatch(resetWorkout());
    };
  }, [dispatch, isNew, workoutId]);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath) {
      const activeTab = menuItems.find(
        (item) => item.path === currentPath
      )?.key;
      activeTab ? setCurrentTab(activeTab) : setCurrentTab(menuItems[0].key);
    }
  }, [location.pathname, menuItems]);

  return (
    <>
      <StyledMenu
        selectedKeys={[currentTab]}
        mode="horizontal"
        items={menuItems}
        onClick={(e) => {
          setCurrentTab(e.key);
          navigate(menuItems.find((item) => item.key === e.key)?.path || ``);
        }}
      />
      <StyledOutletLayout>
        <Outlet />
      </StyledOutletLayout>
    </>
  );
};
